import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { uniqueId } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import RowItem from '../../nucleus/row-item/row-item';
import BottomNav from './BottomNav';
import { Person, PersonType } from '../person';
import formatSubmissionDate from '../../utils/format-submission-date';
import { populateRecipients } from '../../redux/actions/voucher/voucher-actions';
import vouchersService from '../../services/voucher/vouchers-service';

const Confirmation = (props) => {
  const {
    recipients, voucher, deal,
  } = useSelector(state => ({
    recipients: state.voucher.recipients || state.voucher.voucher.send_to_email_addresses,
    voucher: state.voucher.voucher,
    deal: state.deal.deal,
  }));
  const dispatch = useDispatch();
  const history = useHistory();
  const submissionDate = formatSubmissionDate(voucher);
  const dealId = deal?.id;
  const voucherSubmissionStatus = deal?.voucher_submission_status;
  const cameFromSubmit = props.location?.state?.fromSubmit;
  const voucherDeal = voucher.deal;
  const voucherId = voucher.id;
  const voucherSubmitted = !!(
    voucher.submitted_date ||
    voucher.early_invoice_submitted_date ||
    voucher.submission_results?.passed_to_queue_at
  );

  // Guard: redirect to review if the user navigates here directly without submitting.
  // Mirrors Angular's $transitions.onEnter check: !wasSubmitted && fromState !== /send.
  // cameFromSubmit (location.state) covers the immediate post-submit navigation.
  // isAlreadySubmitted (deal status) covers returning to the page after a refresh.
  useEffect(() => {
    if (!dealId) return;
    const submittedStatuses = ['Voucher Submitted', 'Voucher Resubmitted', 'Voucher Completed'];
    const isAlreadySubmitted = submittedStatuses.includes(voucherSubmissionStatus);
    if (!isAlreadySubmitted && !voucherSubmitted && !cameFromSubmit) {
      history.replace(`/voucher/${voucherDeal}/review_and_send/review`);
    }
  }, [cameFromSubmit, dealId, history, voucherDeal, voucherSubmissionStatus, voucherSubmitted]);
  useEffect(() => {
    dispatch(populateRecipients(voucherId));
  }, [dispatch, voucherId]);

  // voucher needs to get refetched manually b/c the latest one doesn't contain early invoice info
  const [isEarlyInvoice, setIsEarlyInvoice] = useState(voucher.is_early_invoice);
  useEffect(() => {
    if (voucherDeal) {
      vouchersService.fetchVoucher(voucherId)
        .then((res) => {
          setIsEarlyInvoice(res.is_early_invoice);
        });
    }
  }, [voucherDeal, voucherId]);
  return (
    <div className="voucher-content confirmation-tab">
      <h2>Congratulations, your {isEarlyInvoice ? 'early invoice request' : 'voucher'} has been sent!</h2>
      <p><span className="label">Time Submitted</span> <strong>{submissionDate}</strong></p>
      <p>We’ve sent your {isEarlyInvoice === true ? 'early invoice request' : 'voucher'} to the following E-Mail Addresses:</p>
      <div>
        {recipients?.map(recipient => (
          <RowItem key={recipient.user_id || uniqueId()} >
            <Person
              person={recipient}
              type={recipient.employee_id ? PersonType.MEMBER : PersonType.RECIPIENT}
            />
          </RowItem>
          ))}
      </div>
      <BottomNav location={props.location.pathname} />
    </div>
  );
};

Confirmation.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }),
};

Confirmation.defaultProps = {
  location: '',
};

export default Confirmation;
